module.exports = __webpack_public_path__ + "Icon_paloma.png";